/**
 * In-App Purchases via RevenueCat — Capacitor scaffold for Lumivera Premium.
 *
 * NOT auto-wired yet. To activate, see /app/memory/MOBILE_LAUNCH_CHECKLIST.md
 * → "In-App Purchases (RevenueCat)" section. Once you have:
 *   - RevenueCat project + iOS & Android API keys
 *   - A "lumivera_premium" non-consumable product in App Store Connect & Play Console
 *   - An "premium" entitlement attached to that product in RevenueCat
 * then set REACT_APP_RC_IOS_KEY and REACT_APP_RC_ANDROID_KEY and call
 * `configurePurchases()` once on app startup after sign-in.
 */
import { Capacitor } from "@capacitor/core";

let configured = false;

export async function configurePurchases(appUserId) {
  if (!Capacitor.isNativePlatform()) return false;
  if (configured) return true;

  const platform = Capacitor.getPlatform();
  const apiKey =
    platform === "ios"
      ? process.env.REACT_APP_RC_IOS_KEY
      : process.env.REACT_APP_RC_ANDROID_KEY;
  if (!apiKey) {
     
    console.warn("RevenueCat API key missing — IAP disabled.");
    return false;
  }

  try {
    const { Purchases, LOG_LEVEL } = await import("@revenuecat/purchases-capacitor");
    await Purchases.setLogLevel({ level: LOG_LEVEL.WARN });
    await Purchases.configure({ apiKey, appUserID: appUserId || null });
    configured = true;
    return true;
  } catch (e) {
     
    console.warn("RevenueCat configure failed", e);
    return false;
  }
}

export async function getOfferings() {
  if (!Capacitor.isNativePlatform()) return null;
  const { Purchases } = await import("@revenuecat/purchases-capacitor");
  const { offerings } = await Purchases.getOfferings();
  return offerings;
}

export async function purchasePremium() {
  if (!Capacitor.isNativePlatform()) return null;
  const { Purchases } = await import("@revenuecat/purchases-capacitor");
  const { offerings } = await Purchases.getOfferings();
  const current = offerings?.current;
  const pkg = current?.availablePackages?.[0];
  if (!pkg) throw new Error("No Premium product available");
  return Purchases.purchasePackage({ aPackage: pkg });
}

export async function hasPremium() {
  if (!Capacitor.isNativePlatform()) return false;
  const { Purchases } = await import("@revenuecat/purchases-capacitor");
  const { customerInfo } = await Purchases.getCustomerInfo();
  return Boolean(customerInfo?.entitlements?.active?.premium);
}
